// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollContainer_container__g9z8q","inner":"ScrollContainer_inner__YfKXQ"};